import { i18n } from '@/i18n';

export const ValidationAmount = (label = 'validation.amount') => (value) => {
  if (value === null || value === '') {
    return true;
  }
  const stringValue = String(value);
  if (
    Number.isNaN(Number(stringValue))
    || stringValue.split('')[0] === '0'
    && stringValue.split('')[1] !== '.') {
    return i18n.t(label);
  }
  return true;
};
